var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4.71875C10.3333 10.941 18.2222 7.31137 21 4.71875",
    stroke: "#202B49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.93558,
    y1: 5.70414,
    x2: 0.354446,
    y2: 7.28528,
    stroke: "#202B49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.2958,
    y1: 9.62316,
    x2: 15.531,
    y2: 7.52194,
    stroke: "#202B49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.23547,
    y1: 7.5216,
    x2: 7.47069,
    y2: 9.62281,
    stroke: "#202B49"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2285,
    y1: 7.28519,
    x2: 19.6473,
    y2: 5.70406,
    stroke: "#202B49"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.8fbb9778ea6a8e968b4f8d03112f4ac2.svg";
export { ForwardRef as ReactComponent };